import { DatabaseOfferItem } from "../types/offers";

export const isRerent = (offerSheetItem: DatabaseOfferItem) =>
  offerSheetItem?.details?.miraItemType === "RERENT";
